// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-in {
    width: 58%;
    text-align: center;
}

@media (max-width: 992px) {
    .publicLoginBoard .MuiFormControl-root {
        width: 80%;
    }

    .sign-in {
        width: 77%;
    }
}

@media (max-width: 700px) {
    .publicLoginBoard .MuiFormControl-root {
        width: 80%;
    }

    .sign-in {
        width: 77%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/PublicLogin.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".sign-in {\n    width: 58%;\n    text-align: center;\n}\n\n@media (max-width: 992px) {\n    .publicLoginBoard .MuiFormControl-root {\n        width: 80%;\n    }\n\n    .sign-in {\n        width: 77%;\n    }\n}\n\n@media (max-width: 700px) {\n    .publicLoginBoard .MuiFormControl-root {\n        width: 80%;\n    }\n\n    .sign-in {\n        width: 77%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
